import ContractType from './ContractType'

class GermanyContractType extends ContractType {
  static urlRoot() {
    return '/contracts/germany/contract_types'
  }
}

export default GermanyContractType
